import { LICENSE_TYPE } from 'Pods/SearchPage/Store/constants'

const licenseFiltersWithAIUsageAllowed = [
  {
    value: LICENSE_TYPE.ALL,
    label: 'All Licenses',
  },
  {
    value: LICENSE_TYPE.ROYALTY_FREE,
    label: 'Royalty Free',
  },
  {
    value: LICENSE_TYPE.EDITORIAL,
    label: 'Editorial Use',
  },
  {
    value: LICENSE_TYPE.CUSTOM,
    label: 'Custom',
  },
]

const licenseFiltersWithoutAIUsageAllowed = [
  {
    value: LICENSE_TYPE.ALL,
    label: 'All Licenses',
  },
  {
    value: LICENSE_TYPE.ROYALTY_FREE_NO_AI,
    label: 'Royalty Free',
  },
  {
    value: LICENSE_TYPE.EDITORIAL_NO_AI,
    label: 'Editorial Use',
  },
  {
    value: LICENSE_TYPE.CUSTOM_NO_AI,
    label: 'Custom',
  },
]

const aiUsageFilters = [{
  value: 'ai_usage_allowed',
  label: 'AI Usage Allowed',
}]

export const getLicenseFiltersConfig = (aiUsageAllowed) => {
  const filters = aiUsageAllowed ? licenseFiltersWithAIUsageAllowed : licenseFiltersWithoutAIUsageAllowed

  return [{
    label: 'LICENSES',
    filters: filters.map(filter => ({
      value: filter.value,
      label: filter.label,
    })),
  }]
}

export const aiUsageFiltersConfig = [{
  label: 'AI USAGE',
  filters: aiUsageFilters.map(filter => ({
    value: filter.value,
    label: filter.label,
  })),
}]
